import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Dialog,
    IconButton,
    makeStyles,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import React, { useMemo, useState } from 'react';
import BrandIframe from 'src/components/BrandIframe';
import Row from 'src/components/Row';
import { Body, Button, Heading, SwipeableDrawer } from 'src/components/UI';
import { useStoreData } from 'src/hooks';
import COLORS from 'src/lib/colors';

const ArrowForward = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
    >
        <path
            d="M2.29289 0.292893C2.65338 -0.0675907 3.22061 -0.0953203 3.6129 0.209705L3.70711 0.292893L7.70711 4.29289C8.06759 4.65338 8.09532 5.22061 7.7903 5.6129L7.70711 5.70711L3.70711 9.70711C3.31658 10.0976 2.68342 10.0976 2.29289 9.70711C1.93241 9.34662 1.90468 8.77939 2.2097 8.3871L2.29289 8.29289L5.585 5L2.29289 1.70711C1.93241 1.34662 1.90468 0.779392 2.2097 0.387101L2.29289 0.292893Z"
            fill="#585858"
        />
    </svg>
);
const InfoIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM12 16.5C12.6213 16.5 13.125 17.0037 13.125 17.625C13.125 18.2463 12.6213 18.75 12 18.75C11.3787 18.75 10.875 18.2463 10.875 17.625C10.875 17.0038 11.3784 16.5002 11.9996 16.5H12ZM11.5766 5.27455C13.4714 5.05924 15.226 6.3002 15.6542 8.15846C16.0825 10.0167 15.0479 11.9005 13.25 12.5361C12.9502 12.6421 12.7498 12.9256 12.75 13.244V14.25C12.75 14.6642 12.4142 15 12 15C11.5858 15 11.25 14.6642 11.25 14.25V13.2444C11.2495 12.2904 11.8506 11.4399 12.75 11.1219C13.8287 10.7405 14.4495 9.61026 14.1925 8.49531C13.9356 7.38035 12.8828 6.63577 11.746 6.76496C10.6091 6.89415 9.75022 7.85597 9.75 9.00014C9.74992 9.41436 9.41407 9.75008 8.99986 9.75C8.58564 9.74992 8.24992 9.41407 8.25 8.99986C8.25036 7.09289 9.68182 5.48987 11.5766 5.27455Z"
            fill="black"
        />
    </svg>
);

const useStyles = makeStyles((theme) => ({
    accordionContainer: {
        boxShadow: 'none',
        borderBottom: '1px solid #CCCCCC',
        '&.Mui-expanded': {
            margin: '0px',
        },
    },
    accordionSummary: {
        padding: '20px 0px 24px 0px',
        minHeight: 'unset !important',
        '& .MuiAccordionSummary-content': {
            margin: '0px',
        },

        '&.Mui-expanded': {
            paddingBottom: '0px',
        },
        '& .MuiIconButton-root': {
            paddingTop: '0px',
            paddingBottom: '0px',
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: '0px',
            // marginBottom: '10px',
        },
    },
    iconButton: {
        '&.MuiIconButton-root': {
            paddingTop: '0px',
            paddingBottom: '0px',
        },
    },
    accordionDetails: {
        padding: '0px 0px 24px 0px',
    },
    inlineDisplay: {
        display: 'inline',
    },
    topHeader: {
        height: 60,
        backgroundColor: COLORS.purple,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
    },
    leftButton: {
        position: 'absolute',
        left: 16,
        top: 22,
    },
}));

const questionAnswerList = [
    {
        question: 'How can I join the Easy Rewards program?',
        beforeLinkText: `You can become an Easy Rewards member by signing up in store, online or in the Staples app. Follow the instructions to create a Staples account and you'll receive access to Easy Rewards program benefits as well`,
        afterLinkText: ``,
        linkText: '',
        linkUrl: '',
    },
    {
        question: 'How do I earn Easy Rewards points?',
        beforeLinkText: `Easy Rewards members earn 1 point for every $1 spent on qualifying purchases made in Staples U.S. stores, on staples.com, in the Staples app, by phone at 800-333-3330 or at Staples via`,
        afterLinkText: `. Members have additional ways to earn points, including making qualifying purchases of their selected bonus points categories, activating and redeeming Easy Rewards offers as well as Ink & Toner recycling.`,
        linkText: 'third-party online marketplaces',
        linkUrl: `${process.env.REACT_APP_DOTCOM_URL}/lp/third-party-online-marketplaces`,
    },
    {
        question: 'What are bonus points categories?',
        beforeLinkText: `Easy Rewards members may select up to 3 bonus points categories at a time, which gives members the opportunity to earn double or more points on qualifying purchases. Members may change their bonus points categories at any time and as often as they want but only 3 bonus categories may be active at one time. For more information, please visit the`,
        afterLinkText: `to select your bonus points categories.`,
        linkText: 'how-to video',
        linkUrl: 'https://share.vidyard.com/watch/JkyLnmvEnjHsYLbCKvoKnv',
    },
    {
        question: 'Where can I view my points balance?',
        beforeLinkText: `Easy Rewards members can view their available points balance in their Easy Rewards dashboard. You'll be able to access your Easy Rewards dashboard by logging into your Easy Rewards account in the Staples app or at staples.com.`,
        afterLinkText: ``,
        linkText: '',
        linkUrl: '',
    },
    {
        question:
            'How long does it take for Easy Rewards points to show up in my account?',
        beforeLinkText: `You`,
        afterLinkText: `Unless otherwise notes, Easy Rewards points for qualifying purchases are usually issued with 24-48 hours after an in-store purchase or shipment of an online or phone order but may take up to 30 business days to be issued. Points earned from qualifying purchases made at Staples via participating third-party online marketplaces are issued within 60 business days after completion of such purchase.`,
        linkText: '',
        linkUrl: '',
    },
    {
        question: `What happens if I return items that earned Easy Rewards points?`,
        beforeLinkText: `Easy Rewards points are subject to forfeiture or adjustment if the qualifying purchase is returned. When an item is returned and a refund is processed, all points earned from the purchase of that item will be debited from the member's account, including any points earned through special Easy Rewards offers related to the purchase. Please visit`,
        afterLinkText: `for more information and to see the Staples Easy Rewards Terms and conditions.`,
        linkText: 'www.staples.com/easy',
        linkUrl: `${process.env.REACT_APP_DOTCOM_URL}/easy`,
    },
    {
        question: 'Where can I earn Easy Rewards points?',
        beforeLinkText: `Easy Rewards points may be earned on qualifying purchases made in store, online, in the Staples app and at Staples via eligible`,
        afterLinkText: ``,
        linkText: 'third-party online marketplaces.',
        linkUrl: `${process.env.REACT_APP_DOTCOM_URL}/lp/third-party-online-marketplaces`,
    },
    {
        question: 'Where and how can I redeem Easy Rewards points?',
        beforeLinkText: `Points may be redeemed for dollars off an Easy Rewards member's purchase amount at checkout. Points may only be redeemed for whole dollar amounts, and 200 points provide $1 to redeem toward the qualifying purchases. Members may select the number of Easy Rewards points (in increments of $1 in value) to redeem and apply to their qualifying purchases. Members can redeem Points in a Staples U.S. store by: (a) scanning their digital Staples Easy Rewards card located in the App or by providing their phone number at checkout, and (b) providing a valid government issued photo identification card. The name on the valid government issued photo identification card must match the name on the Member’s account. If Member is unable to present a valid government issued photo identification card at checkout, then Member will not be able to redeem their Points. Members can redeem Easy Rewards points via staples.com or the Staples app by logging in to their account with their credentials. For full program details, please visit`,
        afterLinkText: `for the Easy Rewards Terms & Conditions.`,
        linkText: 'staples.com/easy',
        linkUrl: `${process.env.REACT_APP_DOTCOM_URL}/easy`,
    },
    {
        question: 'Do my Easy Rewards points expire?',
        beforeLinkText: `Points don't expire so long as your Easy Rewards member account is active. For an account to remain active, a member must earn or redeem at least one point in an 18-month period.`,
        afterLinkText: ``,
        linkText: '',
        linkUrl: '',
    },
    {
        question:
            'Can I donate or transfer my Easy Rewards points to another member?',
        beforeLinkText: `No, not at this time.`,
        afterLinkText: ``,
        linkText: '',
        linkUrl: '',
    },
    {
        question:
            "What can I do if I'm missing points on a recent transaction?",
        beforeLinkText: `Simply log into your Easy Rewards account and submit a missing points request.`,
        afterLinkText: ``,
        linkText: '',
        linkUrl: '',
    },
    {
        question: 'What happens if I forgot to activate my offer(s)?',
        beforeLinkText: `If you forget to activate an Easy Rewards offer, you will not be able to earn the associated points on your transaction. Remember to activate your offers prior to checking out and to check your available offers often so you're always earning as many points on purchases as you can. Find all your latest offers in the Easy Rewards dashboard. Get started by logging into your Easy Rewards account in the Staples app or staples.com. For more information, please visit the`,
        afterLinkText: `to activate your offers`,
        linkText: 'how-to video',
        linkUrl: 'https://share.vidyard.com/watch/JkyLnmvEnjHsYLbCKvoKnv',
    },
    {
        question: 'Can I earn points for recycling ink and toner?',
        beforeLinkText: `Yes, Easy Rewards members may recycle ink or toner cartridges, up to the maximum number displayed in the member's Easy Rewards dashboard, purchased at any U.S. retail store or staples.com, per month and receive points per recycled cartridges. Points earned may take up to 60 business days to be issued. Staples will accept additional cartridges for recycling, but points will only be issued for up to the monthly recycling limit.`,
        afterLinkText: ``,
        linkText: '',
        linkUrl: '',
    },
    {
        question: 'How many ink and toner cartridges can I recycle each month?',
        beforeLinkText: `To see how many ink and toner cartridges you're eligible to recycle and earn points on in a calendar month, first navigate to your Easy Rewards dashboard online. Locate the tile for ink and toner recycling and select "Recycle cartridges." This will open the ink and toner recycling panel. Here, you can see how many ink and toner cartridges you've recycled this month as well as the maximum number of cartridges you may recycle in a calendar month. If using the Staples® app, tap the Store icon in the navigation bar. Scroll down to the Recycling section and you’ll find your maximum number of cartridges you may recycle in a calendar month. Staples will accept additional cartridges for recycling, but points will only be issued for up to the monthly recycling limit of your Easy Rewards account.`,
        afterLinkText: ``,
        linkText: '',
        linkUrl: '',
    },
    {
        question: 'Where can I view my Easy Rewards number?',
        beforeLinkText: `There are three ways of finding your Staples Rewards number: 1. Sign into the Staples mobile app and tap “show my card” in either the account tab or the easy rewards tab. 2. Visit`,
        afterLinkText: `Tap sign in and enter the email address that is associated with your rewards account. (Update to Account Summary-> View all) 3. Contact Customer Service - `,
        linkText: 'staples.com/easy',
        linkUrl: `${process.env.REACT_APP_DOTCOM_URL}/easy`,
        linkText2: 'Contact Us',
        linkUrl2: `${process.env.REACT_APP_DOTCOM_URL}/stores/contact-us`,
    },
    {
        question: 'How do I find Retail Coupons in the App?',
        beforeLinkText: `1. Access by logging into the App. 2. Tap Easy Rewards on the bottom of the screen. 3. Tap “get coupons” on the top right of the screen. 4. Tap on a coupon that you would like to use to show barcode. 5. At checkout, please show barcode of any applicable coupons you would like to use. Terms & Conditions are different for every coupon. Please refer to the bottom of each coupon to find more details.`,
        afterLinkText: ``,
        linkText: '',
        linkUrl: '',
    },
];

const FrequentlyAskedQuestions = () => {
    const { isStoreModeOn } = useStoreData();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [iframeUrl, setIframeUrl] = useState<string>('');
    const [isIframeOpen, setIsIframeOpen] = useState<boolean>(false);
    const [expanded, setExpanded] = useState<string>('');
    const classes = useStyles();

    const scrollToElementById = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
            });
        }
    };

    const onBack = () => {
        if (isIframeOpen) {
            setIsIframeOpen(false);
            setIframeUrl('');
            setTimeout(() => {
                scrollToElementById(expanded);
            }, 500);
        } else {
            setIsOpen(false);
            setExpanded('');
        }
    };

    const onSelectIframe = (url: string) => {
        setIframeUrl(url);
        setIsIframeOpen(true);
    };

    const iframeHeight = useMemo(
        () => (isStoreModeOn ? `calc(100% - 66px)` : '100%'),
        [isStoreModeOn]
    );

    return (
        <>
            <Box
                sx={{
                    mx: '1rem',
                    mb: '25px',
                    borderRadius: '15px',
                    bgcolor: 'white',
                    p: '20px',
                }}
                style={{ cursor: 'pointer' }}
                onClick={() => setIsOpen(true)}
            >
                <Row gap="18px" alignItems={'center'}>
                    <>
                        <InfoIcon />
                        <Row
                            sx={{
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexGrow: 1,
                            }}
                        >
                            <>
                                <Body
                                    size={18}
                                    lineHeight={24}
                                    color="textBlack"
                                >
                                    Frequently Asked Questions
                                </Body>
                                <IconButton
                                    style={{
                                        padding: '3px',
                                    }}
                                >
                                    <ArrowForward />
                                </IconButton>
                            </>
                        </Row>
                    </>
                </Row>
            </Box>
            <Dialog fullScreen open={isOpen} onClose={() => setIsOpen(false)}>
                <Box
                    sx={{
                        height: '100%',
                        position: 'relative',
                    }}
                >
                    <Box className={classes.topHeader}>
                        <Button
                            variant="text"
                            className={classes.leftButton}
                            fontWeight="bold"
                            onClick={onBack}
                        >
                            <img
                                src={require('../../../assets/icons/right-arrow.svg')}
                                alt="arrow icon"
                            />
                        </Button>

                        <Heading
                            type="h3"
                            weight="bold"
                            size={20}
                            color="textWhite"
                        >
                            Frequently Asked Questions
                        </Heading>
                    </Box>

                    {isIframeOpen && (
                        <Box
                            style={{
                                height: 'calc(100% - 60px)',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                padding: isIframeOpen
                                    ? '0px'
                                    : '0px 20px 0px 20px',
                            }}
                        >
                            <BrandIframe
                                title="overview"
                                id={iframeUrl}
                                src={iframeUrl}
                                height={iframeHeight}
                            />
                        </Box>
                    )}

                    {!isIframeOpen && (
                        <Box
                            style={{
                                height: 'calc(100% - 60px)',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                padding: isIframeOpen
                                    ? '0px'
                                    : '0px 20px 0px 20px',
                            }}
                        >
                            {questionAnswerList.map((list, index) => (
                                <Accordion
                                    className={classes.accordionContainer}
                                    // key={`${list.question}_${}`}
                                    expanded={
                                        expanded === `${list.question}_${index}`
                                    }
                                    onChange={(_event, isExpanded) =>
                                        setExpanded(
                                            isExpanded
                                                ? `${list.question}_${index}`
                                                : ''
                                        )
                                    }
                                >
                                    <AccordionSummary
                                        expandIcon={
                                            <ExpandMore
                                                className={classes.iconButton}
                                            />
                                        }
                                        aria-controls="panel1a-content"
                                        id={`${list.question}_${index}`}
                                        className={classes.accordionSummary}
                                    >
                                        <Body
                                            size={16}
                                            lineHeight={20}
                                            color="textBlack"
                                        >
                                            {list.question}
                                        </Body>
                                    </AccordionSummary>
                                    <AccordionDetails
                                        className={classes.accordionDetails}
                                    >
                                        <Box
                                            sx={{
                                                paddingTop: '10px',
                                            }}
                                        >
                                            <Body
                                                size={14}
                                                weight="light"
                                                lineHeight={18}
                                                className={
                                                    classes.inlineDisplay
                                                }
                                            >
                                                {list.beforeLinkText}{' '}
                                            </Body>
                                            {list.linkText.length > 0 && (
                                                <Box
                                                    onClick={() =>
                                                        onSelectIframe(
                                                            list.linkUrl
                                                        )
                                                    }
                                                    className={
                                                        classes.inlineDisplay
                                                    }
                                                >
                                                    <Body
                                                        size={14}
                                                        weight="light"
                                                        color="textLinkBlue"
                                                        lineHeight={18}
                                                        className={
                                                            classes.inlineDisplay
                                                        }
                                                    >
                                                        {' '}
                                                        {list.linkText}{' '}
                                                    </Body>
                                                </Box>
                                            )}
                                            {list.afterLinkText.length > 0 && (
                                                <Body
                                                    size={14}
                                                    weight="light"
                                                    lineHeight={18}
                                                    className={
                                                        classes.inlineDisplay
                                                    }
                                                >
                                                    {list.afterLinkText}{' '}
                                                </Body>
                                            )}
                                            {list.linkText2 &&
                                                list.linkText2.length > 0 && (
                                                    <Box
                                                        onClick={() =>
                                                            onSelectIframe(
                                                                list?.linkUrl2
                                                            )
                                                        }
                                                        className={
                                                            classes.inlineDisplay
                                                        }
                                                    >
                                                        <Body
                                                            size={14}
                                                            weight="light"
                                                            color="textLinkBlue"
                                                            lineHeight={18}
                                                            className={
                                                                classes.inlineDisplay
                                                            }
                                                        >
                                                            {' '}
                                                            {
                                                                list.linkText2
                                                            }{' '}
                                                        </Body>
                                                    </Box>
                                                )}
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </Box>
                    )}
                </Box>
            </Dialog>
        </>
    );
};

export default FrequentlyAskedQuestions;
